import { render } from "./index.vue?vue&type=template&id=c105b87c&scoped=true&bindings={}"
import script from "./shows-info.js?vue&type=script&lang=js"
export * from "./shows-info.js?vue&type=script&lang=js"

import "./shows-info.scss?vue&type=style&index=0&id=c105b87c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c105b87c"

export default script